import VehicleAccessType from '@/models/Shared/VehicleAccessType'

export default class VehicleAccessTypeViewModel {
    name: string;
    value: VehicleAccessType;

    public constructor(name: string, value: VehicleAccessType) {
        this.name = name;
        this.value = value;
    }
}